import { fetchOdds } from "../api/api";
import { Tabs } from "../../model/model";

// Load odds data for a specific tab only
export const loadNextOddsPage = (store, opts = {}) => {
  const activeTab = opts?.tab || Tabs.FullTime;
  const page = store.getLastLoadedPage(activeTab) + 1;
  const filter = store.getFilter();
  const searchQuery = store.getSearchQuery();
  const mode = store.getMode();
  const selectedBet = store.getSelectedBet();

  // If silent or pagination, don't set main loading spinner
  if (opts.silent || opts.pagination) {
    store.setPaginationLoading(true);
  } else {
    store.setLoadingForTab(activeTab, true);
  }

  fetchOdds({
    tab: activeTab,
    filter,
    searchQuery,
    page,
    mode,
    selectedBet,
    setGoals: store.setGoals,
  })
    .then((data) => {
      opts?.onBeforeSuccess?.();

      store.insertOddsData(activeTab, data);
      store.setLastLoadedPage(activeTab, page);

      opts?.onSuccess?.(data.length);
    })
    .catch((e) => {
      opts?.onError?.(e);
    })
    .finally(() => {
      if (opts.silent || opts.pagination) {
        store.setPaginationLoading(false);
      } else {
        store.setLoadingForTab(activeTab, false);
      }
      opts?.onFinally?.();
    });
};
